import { isNativeAppPlatform } from "@/lib/native/platform";

export type NativeFeelCapability =
  | "haptics"
  | "swipe"
  | "nativeMedia"
  | "nativeVideoPlayer"
  | "modalMotion"
  | "systemUi";

const NATIVE_FEEL_PREFIX = "nativeFeel:";

function readNativeFeelOverride(capability: NativeFeelCapability): boolean | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(`${NATIVE_FEEL_PREFIX}${capability}`);
  if (raw === "1" || raw === "true") return true;
  if (raw === "0" || raw === "false") return false;
  return null;
}

export function isNativeFeelEnabled(capability: NativeFeelCapability): boolean {
  if (!isNativeAppPlatform()) return false;
  const override = readNativeFeelOverride(capability);
  if (override != null) return override;
  return true;
}

export type FeatureFlag = "shareAnalysisCard";

const FEATURE_FLAG_PREFIX = "featureFlag:";

function readFeatureFlagOverride(flag: FeatureFlag): boolean | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(`${FEATURE_FLAG_PREFIX}${flag}`);
  if (raw === "1" || raw === "true") return true;
  if (raw === "0" || raw === "false") return false;
  return null;
}

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  const override = readFeatureFlagOverride(flag);
  if (override != null) return override;
  return true;
}
